import {Directive, ElementRef, Input, numberAttribute, Renderer2} from '@angular/core';
import {debounceTime, fromEvent, throttleTime} from 'rxjs';

@Directive({
  selector: '[appFullHigh]'
})
export class FullHeighDirective {
  private domEl: HTMLElement;
  minHeight: number = 100;
  topOffset: number | undefined;
  @Input({transform: numberAttribute}) bottomOffset : number | undefined;

  constructor(private renderer: Renderer2, private el: ElementRef) {
    this.domEl = this.el.nativeElement as HTMLElement;
    fromEvent(window, 'resize')
        .pipe(throttleTime(500), debounceTime(500))
        .subscribe(() => {
          this.setHeight();
        });
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.setHeight();
    }, 100)

  }
  setHeight() {
    const windowHeight = window?.innerHeight;
    const topOffset = this.topOffset || this.calcTopOffset();
   /// console.log('topOffset', topOffset);
    let height: number
    if (!this.bottomOffset) {
      height = windowHeight - topOffset;
    } else {
      height = windowHeight
    }

    // console.log('height first', height);
    if (this.bottomOffset) {
      height -= this.bottomOffset;
      // console.log('- bottomOffset', this.bottomOffset);
    }


    // set min height instead of the calculated
    if (this.minHeight && height < this.minHeight) {
      height = this.minHeight;
    }
   // console.log('height last', height);

    this.renderer.setStyle(this.domEl, "height", `${height}px`);
  }

  private calcTopOffset(): number {
    try {
      const rect = this.domEl.getBoundingClientRect();
      const scrollTop =
          window.scrollY || document.documentElement.scrollTop;

      return rect.top + scrollTop;
    } catch (e) {
      return 0;
    }
  }

}
